"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/ui/components");
var _validators = require("vuelidate/lib/validators");
var _vuex = require("vuex");
var _constants = require("@/config/constants");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default2 = exports.default = {
  name: 'ModalDetailCustomField',
  components: {
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect
  },
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    onSuccess: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      idItem: null,
      listTypesCustomFields: _constants.LIST_CUSTOM_FIELDS,
      typesSelects: ['select', 'radio', 'seekbar', 'checklist'],
      form: {
        name: '',
        label: '',
        description: '',
        placeholder: null,
        input: '',
        type: '',
        value: null
      },
      options: [{
        name: '',
        value: '',
        order: null
      }]
    };
  },
  computed: {
    isContainOptions: function isContainOptions() {
      return _constants.LIST_CUSTOM_FIELDS_OPTIONS.includes(this.form.type);
    },
    isEditable: function isEditable() {
      return !!this.idItem;
    }
  },
  mounted: function mounted() {
    if (this.item) {
      this.idItem = this.item.id;
      this.getData();
    }
  },
  validations: {
    form: {
      name: {
        required: _validators.required
      },
      label: {
        required: _validators.required
      },
      description: {},
      placeholder: {},
      input: {},
      type: {
        required: _validators.required
      },
      value: {}
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getCustomFieldItem', 'createCustomField', 'editCustomField', 'deleteOptionCustomField'])), {}, {
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _data$options,
          _this = this;
        var data, options;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.getCustomFieldItem(this.item.id);
            case 1:
              data = _context.v;
              options = (_data$options = data === null || data === void 0 ? void 0 : data.options) !== null && _data$options !== void 0 ? _data$options : [];
              options = options.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  customFieldId: undefined
                });
              });
              if (data) {
                if (data.options) {
                  this.options = options;
                }
                Object.keys(data).map(function (key) {
                  if (data[key]) _this.form[key] = data[key];
                });
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    addOption: function addOption() {
      var item = {
        name: '',
        value: '',
        order: null
      };
      this.options.push(item);
    },
    removeOption: function () {
      var _removeOption = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(i, item) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.options.splice(i, 1);
              if (!item.id) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return this.deleteOptionCustomField(item.id);
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function removeOption(_x, _x2) {
        return _removeOption.apply(this, arguments);
      }
      return removeOption;
    }(),
    validOptionsFields: function validOptionsFields() {
      var fields = this.options.filter(function (i) {
        return !i.name || !i.value;
      });
      return !fields.length;
    },
    resolved: function () {
      var _resolved = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
        var payload, fn, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              e.preventDefault();
              this.$v.form.$touch();
              if (!(this.$v.form.$invalid || this.isContainOptions && !this.validOptionsFields())) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, this.$buefy.toast.open({
                duration: 5000,
                message: "Por favor, verifique os campos <b>obrigat\xF3rios</b>!",
                position: 'is-top',
                type: 'is-danger'
              }));
            case 1:
              payload = {
                name: this.form.name,
                label: this.form.label,
                description: this.form.description,
                placeholder: this.form.placeholder,
                input: this.form.type,
                type: this.form.type,
                value: this.form.value
              };
              if (this.isContainOptions) {
                payload.options = this.options;
              }
              fn = this.createCustomField;
              if (this.idItem) {
                fn = this.editCustomField;
              }
              _context3.n = 2;
              return fn({
                payload: payload,
                id: this.idItem
              });
            case 2:
              data = _context3.v;
              if (data) {
                this.$parent.close();
                this.$emit('onSuccess');
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function resolved(_x3) {
        return _resolved.apply(this, arguments);
      }
      return resolved;
    }(),
    cancelModal: function cancelModal() {
      this.$parent.close();
    }
  })
};